export default class TaskInfoKind {

  static CONTEXT_INIT = 'CONTEXT_INIT';
	static NEW_STATE = 'NEW_STATE';
	static NEW_QUEUE_POSITION = 'NEW_QUEUE_POSITION';
	static PROGRESS_CHANGED = 'PROGRESS_CHANGED';
	static NEW_MESSAGE = 'NEW_MESSAGE';

}
